<template>
    <div>
        <page-navigate></page-navigate>
        <div :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')">
      <section class="section1">
        <h1 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.差价合约') }}</h1>
        <p class="p1">
          {{ $t('etf.把握全球') }}
        </p>
        <a :href="signupUrl" target="_blank" class="btn mt-52">{{ $t('etf.即刻开户') }}</a>
      </section>
      <section class="section2">
        <h2 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.优势') }}</h2>
        <p class="describe"> {{ $t('etf.差价合约是一种') }}</p>
        <div class="section2-content">
          <div class="section2-content-item">
            <img
              class="section2-item-img"
              src="@/assets/image/trading-product/etf/section2Icon1.svg"
              alt=""
            />
            <div class="section2-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.品种丰富') }}</h3>
              <p class="info1">{{ $t('etf.支持100') }}</p>
            </div>
          </div>
          <div class="section2-content-item">
            <img
              class="section2-item-img"
              src="@/assets/image/trading-product/etf/section2Icon2.svg"
              alt=""
            />
            <div class="section2-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.灵活交易') }}</h3>
              <p class="info1">{{ $t('etf.支持买入') }}</p>
            </div>
          </div>
          <div class="section2-content-item">
            <img
              class="section2-item-img"
              src="@/assets/image/trading-product/etf/section2Icon3.svg"
              alt=""
            />
            <div class="section2-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.无需持有') }}</h3>
              <p class="info1">{{ $t('etf.无需持有资产') }}</p>
            </div>
          </div>
          <div class="section2-content-item">
            <img
              class="section2-item-img"
              src="@/assets/image/trading-product/etf/section2_item4.svg"
              alt=""
            />
            <div class="section2-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.杠杆交易') }}</h3>
              <p class="info1">{{ $t('etf.杠杆配置') }}</p>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <a class="btn" :href="$store.state.mnUrl" rel="nofollow">
            {{ $t('etf.开设模拟账户') }}
            <svg class="mobile" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M1.02803 11.4087C1.05199 10.0528 1.60019 8.75823 2.55852 7.7946C3.51685 6.83098 4.81146 6.27252 6.17285 6.23548C6.21913 6.23526 6.26343 6.21673 6.296 6.18399C6.32857 6.15124 6.34674 6.10694 6.34651 6.06086C6.34629 6.01477 6.32769 5.97066 6.29481 5.93823C6.26192 5.9058 6.21744 5.8877 6.17116 5.88793C4.80008 5.85828 3.49367 5.30171 2.52534 4.33471C1.55701 3.36771 1.00182 2.06521 0.975948 0.699822" stroke="#A52933" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          <a class="btn btn-light" :href="$store.state.khUrl">
             {{ $t('etf.开设真实账户') }}
            <svg class="mobile" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M1.02803 11.4087C1.05199 10.0528 1.60019 8.75823 2.55852 7.7946C3.51685 6.83098 4.81146 6.27252 6.17285 6.23548C6.21913 6.23526 6.26343 6.21673 6.296 6.18399C6.32857 6.15124 6.34674 6.10694 6.34651 6.06086C6.34629 6.01477 6.32769 5.97066 6.29481 5.93823C6.26192 5.9058 6.21744 5.8877 6.17116 5.88793C4.80008 5.85828 3.49367 5.30171 2.52534 4.33471C1.55701 3.36771 1.00182 2.06521 0.975948 0.699822" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </section>
      <section class="section5 section2">
        <h2 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.如何开始交易') }}</h2>
        <div class="section5-content">
          <div class="section5-content-item">
            <a :href="loginUrl"><img
              class="section5-item-img"
              src="@/assets/image/trading-product/etf/section5Step1.png"
              alt=""
            />
            <div class="section5-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.注册账号') }}</h3>
              <p class="info1">{{ $t('etf.注册并登录') }}</p>
            </div></a>
          </div>
          <div class="section5-content-item">
            <a href="/MT5"><img
              class="section5-item-img"
              src="@/assets/image/trading-product/etf/section5Step2.png"
              alt=""
            />
            <div class="section5-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.下载MT5交易平台') }}</h3>
              <p class="info1">{{ $t('etf.开通真实交易账号') }}</p>
            </div></a>
          </div>
          <div class="section5-content-item">
            <a :href="loginUrl"><img
              class="section5-item-img"
              src="@/assets/image/trading-product/etf/section5Step3.png"
              alt=""
            />
            <div class="section5-item-content">
              <h3 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">{{ $t('etf.开始交易') }}</h3>
              <p class="info1">{{ $t('etf.选择ETF') }}</p>
            </div></a>
          </div>
        </div>
        <div class="btn-box">
          <a class="btn" :href="loginUrl" rel="nofollow">
            {{ $t('etf.即刻交易') }}
            <svg class="mobile" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M1.02803 11.4087C1.05199 10.0528 1.60019 8.75823 2.55852 7.7946C3.51685 6.83098 4.81146 6.27252 6.17285 6.23548C6.21913 6.23526 6.26343 6.21673 6.296 6.18399C6.32857 6.15124 6.34674 6.10694 6.34651 6.06086C6.34629 6.01477 6.32769 5.97066 6.29481 5.93823C6.26192 5.9058 6.21744 5.8877 6.17116 5.88793C4.80008 5.85828 3.49367 5.30171 2.52534 4.33471C1.55701 3.36771 1.00182 2.06521 0.975948 0.699822" stroke="#A52933" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </section>
      <section class="section3">
        <h2 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'">市场报价</h2>
        <div class="product" style="width: auto;">
          <ProductModule></ProductModule>
        </div>
        <div class="btn-box">
          <a class="btn" href="/AllProducts/">
            查看所有产品
            <svg class="mobile" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M1.02803 11.4087C1.05199 10.0528 1.60019 8.75823 2.55852 7.7946C3.51685 6.83098 4.81146 6.27252 6.17285 6.23548C6.21913 6.23526 6.26343 6.21673 6.296 6.18399C6.32857 6.15124 6.34674 6.10694 6.34651 6.06086C6.34629 6.01477 6.32769 5.97066 6.29481 5.93823C6.26192 5.9058 6.21744 5.8877 6.17116 5.88793C4.80008 5.85828 3.49367 5.30171 2.52534 4.33471C1.55701 3.36771 1.00182 2.06521 0.975948 0.699822" stroke="#A52933" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </section>
      <section class="section4">
        <h2 :class="(['cn','tw'].includes($t('cfds.lang'))?'cn':'en')+'-font-family-title'"> {{ $t('etf.差价合约相关问题') }}</h2>
        <div class="QA-list">
          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 6 }">
            <div class="QA-font-family-title" @click="QAOpen(6)">{{ $t('etf.ETF是什么') }}</div>
            <div class="QA-content">
              <p class="QA-li">
                {{ $t('etf.ETF全称是') }}
            </p>
            </div>
          </div>
          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 0 }">
            <div class="QA-font-family-title" @click="QAOpen(0)">{{ $t('etf.有什么区别') }}</div>
            <div class="QA-content">
              <p class="QA-li">
                {{ $t('etf.是差价合约交易') }}
            </p>
            </div>
          </div>
          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 1 }">
            <div class="QA-font-family-title" @click="QAOpen(1)"> {{ $t('etf.购买ETF才能交易') }}</div>
            <div class="QA-content">
              <p class="QA-li">
                 {{ $t('etf.通过EBC提供的ETF') }}
              </p>
            </div>
          </div>

          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 2 }">
            <div class="QA-font-family-title" @click="QAOpen(2)">{{ $t('etf.交易会收取哪些费')}}</div>
            <div class="QA-content">
              <p class="QA-li">
                {{ $t('etf.您无需支付传统ETF的管理费')}}
                 </p>
            </div>
          </div>
          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 3 }">
            <div class="QA-font-family-title" @click="QAOpen(3)">{{ $t('etf.可以做空吗')}}</div>
            <div class="QA-content">
              <p class="QA-li">
                {{ $t('etf.与传统ETF只能做多不')}}
              </p>
            </div>
          </div>
          <div class="QA-item" :class="{ 'QA-actived': QAIndex == 4 }">
            <div class="QA-font-family-title" @click="QAOpen(4)">{{ $t('etf.适合新手交易者')}}</div>
            <div class="QA-content">
              <p class="QA-li">
            {{ $t('etf.CFD产品具有杠杆属性')}}    
            </p>
            </div>
          </div>
        </div>
      </section>
      <ss-contact-us-new mode="all"></ss-contact-us-new>
    </div>
     <page-footer></page-footer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data(){
    return {
      QAIndex:-1
    }
  },
  methods:{
    QAOpen(index){
      console.log(index)
      this.QAIndex = this.QAIndex == index ? -1 : index;
    }
  },
  computed: {
        ...mapGetters([
            'language',
            'FCAUrl',
            'signupUrl',
            'loginUrl',
        ])
    },
}
</script>
<style lang="scss">
@charset "UTF-8";
@import url("../assets/css/font-family.css");
.section1 {
  height: 333rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("../assets/image/trading-product/etf/section1Bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.section1 h1 {
  color: #fff;
  text-align: center;
  font-size: 40rem;
  font-style: normal;
  font-weight: 900;
  line-height: 48rem;
}
.section1 .p1 {
  margin-top: 25rem;
  color: #fff;
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 25rem;
  padding: 0 180rem;
  max-width: 70vw;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41rem;
  min-width: 200rem;
  border-radius: 2rem;
  background: #fff;
  padding: 14rem 20rem;
  color: #a52933;
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  transition: all 0.3s;
}
.btn:hover {
  background: #a52933;
  color: #fff;
}

.btn-light {
  background: #a52933;
  color: #fff;
}
.section2 .btn-light:hover {
  background: #9f734c;
  border-color: #9f734c;
  /* color: #a52933; */
}
.mt-52 {
  margin-top: 40rem;
}

.section2,
.section3,
.section4 {
  padding: 120rem 150rem;
}

.section2 h2,
.section3 h2,
.section4 h2 {
  color: #a52933;
  text-align: center;
  font-size: 36rem;
  font-style: normal;
  font-weight: 900;
  line-height: 1em;
}
.bottom-line{
  margin: 30rem auto 0;
  width: 100rem;
  height: 2px;
  background-color: #a52933;
}
.section2 .describe {
  color: #666;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 28rem; /* 155.556% */
  margin:50rem auto 0;
  max-width:calc(100% - 380rem)
  /* margin:0 auto; */
}
.section2 .p1 {
  margin-top: 38rem;
  color: #666;
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 28rem;
  padding: 0 180rem;
}
.section2-content {
  margin: 120rem auto 0;
  max-width: 1200rem;
  display: flex;
  flex-wrap: wrap;
  gap: 75rem;
  justify-content: space-between;
}
.section2-content-item {
  display: flex;
  align-items: center;
  gap: 25rem;
}
.section2-item-content {
  width: 300rem;
}
.section2-item-img {
  width: 102rem;
  height: 102rem;
}
.section2-content-item h3 {
  color: #a52933;
  font-size: 18rem;
  font-style: normal;
  font-weight: 700;
  line-height: 30rem;
}
.section2-content-item .info1 {
  margin-top: 8rem;
  color: #6a6967;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 30rem;
}
.section5 {
  padding:120rem 300rem;
}
.section5 .section5-content {
  display:flex;
  justify-content: space-between;
  margin-top:124rem;
}
.section5 .section5-item-img {
  width:170rem;
  height:100rem;
  transform: scale(.8);
}
.section5-content .section5-item-content{
  margin-top:40rem;

}
.section5-content .section5-content-item:hover h3 {
  color:#A52933;
}
.section5-content .section5-content-item:hover {
    box-shadow: 0px 30px 100px 0px rgba(0, 0, 0, 0.10);
    transform: translateY(-20px);
    background:transparent;
  }
  .section5-content .section5-content-item:hover::after {
    position:absolute;
    content:'';
    width:100%;
    left:0;
    bottom:0;
    height:8rem;
    background:#A52933;
  }
.section5-content  .section5-content-item {
  position:relative;
  flex:0 0 310rem;
  padding:50rem 10rem 30rem;
  overflow:hidden;
  transition: transform 0.5s;
  cursor:pointer;
  background:url('../assets/image/trading-product/etf/linearBorder.png');
  background-size:100% 100%;
  border-radius:10rem;
}
.section5-content,.section5-item-content h3{
  color: #000;
  text-align:center;
  font-size: 24rem;
  font-weight: 700;
  margin-bottom:25rem
}
.section5-content,.section5-item-content .info1{
  color: #666;
  font-size: 16rem;
  font-weight: 400;
  line-height: 28rem;
}
.section2 .btn-box,
.section3 .btn-box {
  margin-top: 110rem;
  display: flex;
  justify-content: center;
  gap: 25rem;
}
.section2 .btn,
.section3 .btn {
  border: 1px solid #a52933;
}

.section3 {
  background-color: #f6f6f6;
}
.section3 .product {
  margin-top: 108rem;
}

.QA-list {
  width: 1024rem;
  margin: 0 auto;
  margin-top: 108rem;
}
.QA-item {
  padding: 22rem;
}

.QA-item:hover {
  box-shadow: 0 12px 18px -6px rgba(34, 56, 101, 0.12);
}

.QA-font-family-title {
  position: relative;
  color: #232222;
  font-size: 18rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
  padding-right: 20rem;
}
.QA-font-family-title::after {
  position: absolute;
  right: 0;
  top: 4rem;
  content: "\e61a";
  color: #949699;
  font-family: "iconfont" !important;
  font-size: 16rem;
  transition: all 0.3s;
}

.ar .QA-font-family-title {
  padding-left: 20rem;
  padding-right: 0;
}
.ar .QA-font-family-title::after {
  right: unset;
  left: 0;
}

.QA-actived .QA-font-family-title::after {
  transform: rotate(180deg);
}
.QA-actived .QA-content{
    display: block;
}
.QA-content {
  margin-top: 12rem;
  display: none;
}
.QA-li {
  position: relative;
  color: #6a6967;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 28rem;
  padding-left: 28rem;
}
.QA-li::before {
  content: "";
  position: absolute;
  left: calc(14rem - 2rem);
  top: calc(14rem - 2rem);
  width: 4rem;
  height: 4rem;
  background-color: #6a6967;
  border-radius: 50%;
}
.ar .QA-li {
  padding-left: 0;
  padding-right: 28rem;
}
.ar .QA-li::before {
  left: unset;
  right: calc(14rem - 2px);
}

@media (max-width: 996px) {
  .section1 {
    background: url("../assets/image/trading-product/etf/section1BgM.png");
    /* background-size: cover; */
    background-repeat: no-repeat;
    background-size: 100% 100%;

  }
  .section2,
  .section3 {
    padding: 100rem 28rem;
  }
  .section4 {
    padding: 100rem 80rem;
  }
  .section2 h1,
  .section3 h1,
  .section4 h1 {
    font-size: 40rem;
  }
  .section2 h2,
.section3 h2,
.section4 h2 {
  font-size:44rem;
}
  .section1 .p1,
  .section2 .p1 {
    padding: 0 30rem;
    font-size: 20rem;
    line-height: normal;
    margin-top: 26rem;
  }
  .section2 {
    padding:100rem 65rem;
  }
  .section2 .describe{
    font-size:24rem;
     max-width:calc(100% - 50rem)
  }
  .section2-content {
    padding: 0 45rem;
    margin-top: 85rem;
    gap: 78rem 60rem;
  }
  .section2-content-item {
    flex-direction: column;
    align-items: center;
    gap: 20rem;
    width: calc(50% - 40rem);
  }
  .section2-content-item .info1 {
    line-height: normal;
  }
  .section2-item-content {
    width: 100%;
  }
  .section2-content-item h3 {
    font-size: 24rem;
    text-align: center;
  }
  .section2-content-item .info1 {
    font-size: 20rem;
    text-align: center;
  }
  .section2 .btn-box,
  .section3 .btn-box {
    margin-top: 85rem;
  }
  .btn-box {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .btn {
    min-width: 334rem;
    height: 68rem;
    font-size: 24rem;
    svg {
      width:10rem;
      height:15rem;
      margin-left:10rem;
    }
  }
  .section2-item-img {
    width: 105rem;
    height: 105rem;
  }
  .section3 .product {
    margin-top: 85rem;
  }
  .QA-list {
    width: 100%;
    margin-top: 70rem;
  }
  .QA-item:hover {
    box-shadow: none;
  }
  .QA-font-family-title {
    font-size: 24rem;
  }
  .QA-li {
    font-size: 20rem;
    line-height: 30rem;
  }
  .section5 .section5-content {
    flex-wrap:wrap;
  }
  .section5 .section5-content .section5-content-item {
    flex:0 0 280rem;
    padding:30rem 15rem;
  }
  .section5 .section5-content .section5-content-item:first-child{
    flex:0 0 50vw;
    margin:0 auto
  }
  .section5 .section5-content .section5-content-item:nth-child(n+2){
    margin-top:80rem;
  }
  .section5 .section5-content .section5-item-content h3 {
    margin-bottom:15rem;
    font-size:24rem;
  }
  .section5 .section5-content .section5-item-content .info1 {
    font-size:20rem;
    max-width:50vw;
    margin:0 auto;
  }
}

</style>